export const selectPermissions = (state) => state?.permissionsData;
export const selectUser = (state) => state?.userData?.data;
export const selectTimezone = (state) => state?.userData?.time_zone;
export const selectPatientUser = (state) => state.patientUserData?.data;
export const selectLeads = (state) => state?.leadsData;
export const selectPatients = (state) => state?.patientsData;
export const selectOrders = (state) => state?.ordersData;
export const selectCases = (state) => state?.casesData;
export const selectSubscriptions = (state) => state?.subscriptionsData;
export const selectProducts = (state) => state?.productsData;
export const selectTickets = (state) => state?.ticketsData;
export const selectQuestionnaires = (state) => state?.questionnairesData;
export const selectStatuses = (state) => state?.statusesData;
export const selectVouchers = (state) => state?.vouchersData;
export const selectUsers = (state) => state?.usersData;
export const selectQuickFilters = (state) => state?.quickLinksData;
export const selectTeams = (state) => state?.teamsData;
export const selectTokens = (state) => state?.tokensData;
export const selectTrackings = (state) => state?.trackingsData;
export const selectTemplates = (state) => state?.templatesData;
export const selectUserDashboard = (state) => state?.userDashboardData;
export const selectNotifications = (state) => state?.notificationsData;
export const selectSupportChat = (state) => state?.supportChatData;
export const selectSupportConversations = (state) => state?.supportConversationsData;
export const selectPatientOrders = (state) => state?.patientOrdersData;
export const selectPatientSubscriptions = (state) => state?.patientSubscriptionsData;
export const selectUserProfile = (state) => state?.userProfileData;
export const selectClientUser = (state) => state?.clientUserData;
export const selectFilters = (state) => state?.filtersData;
export const selectGmail = (state) => state?.gmailData;
export const selectTypes = (state) => state?.typesData;
export const selectleadDetails = (state) => state?.leadDetailsData;
export const selectExports = (state) => state?.exportsData;
export const selectAppointments = (state) => state?.appointmentsData;
export const selectFollowUp = (state) => state?.followUpData;
export const selectRoles = (state) => state?.rolesData;
export const selectCurrentTenant = (state) => state?.tenantConfigData;
export const selectLabWorks = (state) => state?.labWorksData;
export const selectUserProducts = (state) => state?.userProductsData;
export const selectCoupons = (state) => state?.couponsData;
export const selectAgentSales = (state) => state?.agentSalesData;
export const selectQuizAttempts = (state) => state?.quizAttemptsData;
export const selectUserAffiliateProgram = (state) => state?.userAffiliateProgramData;
export const selectUserAgentSales = (state) => state?.userAgentSalesData;
export const selectPatientReferrals = (state) => state?.patientReferralsData;
export const selectLabReviews = (state) => state?.labReviewsData;
export const selectProductVariants = (state) => state?.productVariantsData;
export const selectIntakeFormData = (state) => state?.intakeFormData;
export const selectSupportTemplatesData = (state) => state.supportTemplatesData;
export const selectCharges = (state) => state?.chargesData;
export const selectContacts = (state) => state?.contactsData;
export const selectIntakes = (state) => state?.intakesData;
